<template>
    <main class="CategoriaDetalle-MAIN DISPLAY" :style="`background-color: ${currentCategory?.color};`">
    <main class="INNER-MARGIN">

        <div>
            <img :src="require(`../assets/${currentCategory?.cover}.png`)" v-if="categoryId != 0">
        </div>

        <br>
        <br>

        <img src="../assets/destacados.png"/>
        <div v-if="cuponesData.length > 0">
            <a v-for="(item, index) in cuponesData" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id+'&categoria='+categoryId">
                <!--<div v-html="categoryHelper(item.categoria_id, item.nombre, item.cupon_id)"></div>-->
                <img :src="item.url_banner"  @error="(e) => { e.target.onerror = null; e.target.src = 'https://promo-colaboradores.ideeo.mx/cupones/NULL%20BANNER.png';}"/>
            </a>
        </div>
        <h2 v-else><i>{{ loading ? 'Cargando...' : 'Próximamente' }}</i></h2>

        <img src="../assets/nuevos.png"/>
        <div v-if="cuponesData.length > 0">
            <a v-for="(item, index) in cuponesData" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id+'&categoria='+categoryId">
                <img :src="item.url_banner"  @error="(e) => { e.target.onerror = null; e.target.src = 'https://promo-colaboradores.ideeo.mx/cupones/NULL%20BANNER.png';}"/>
            </a>
        </div>
        <h2 v-else><i>{{ loading ? 'Cargando...' : 'Próximamente' }}</i></h2>

    </main>
    </main>
</template>

<script>
export default {
    name: 'CategoriaDetalle',
    data(){
        return{
            categoryId: 0,
            cuponesData: [],
            categoryDict: [
                { name: "", image: "" },
                { name: "A la aventura", image: "aeroplane", bgColor: "#FCF9EB"}, //1
                { name: "Estudiante", image: "estudiante" },
                { name: "Comida", image: "comida" },
                { name: "Mascotas", image: "mascotas" },
                { name: "Mundo Fitness", image: "bicycle", bgColor: "#E9E8FE"}, //5
                { name: "Mundo Digital", image: "business-inteligent", bgColor: "#FFF5FE"}, //6
                { name: "Vida en compañía", image: "couple", bgColor: "#E6F2FF" }, //7
                { name: "Nuevo hogar", image: "nuevo-hogar" },
                { name: "Vida en pareja", image: "vida-pareja" },
                { name: "Naciminto", image: "nacimiento" },
                { name: "Vida independiente", image: "decease", bgColor: "#F6FEF3"}, //11

                {id: 11, color: "#EEFFE9", name: "Vida independiente", icon: "decease.png", bg: "min-cover-vida-independiente.png", cover: "full-cover-vida-independiente"},
                {id: 1, color: "#FFFAE2", name: "A la aventura", icon: "aeroplane.png", bg: "min-cover-a-la-aventura.png", cover: "full-cover-a-la-aventura"},
                {id: 6, color: "#FFEEFE", name: "Mundo digital", icon: "business-inteligent.png", bg: "min-cover-vida-digital.png", cover: "full-cover-mundo-digital"},
                {id: 5, color: "#D4D1FC", name: "Mundo Fitness", icon: "bicycle.png", bg: "min-cover-fitness.png", cover: "full-cover-fitness"},
                {id: 7, color: "#D7E8FC", name: "Vida en compañía", icon: "couple.png", bg: "min-cover-compania.png", cover: "full-cover-compania"},

                {id: 12, color: "#FCE677", name: "Detalles que inspiran", icon: "kids.png", bg: "min-cover-detalles.png", cover: "full-cover-detalles"}, //faltan ids reales
                {id: 13, color: "#9FE38E", name: "Ecovibes", icon: "climate-action.png", bg: "min-cover-eco.png", cover: "full-cover-eco"}, //faltan ids reales
                {id: 14, color: "#92C8FB", name: "Cuida tu salud", icon: "insurance.png", bg: "min-cover-salud.png", cover: "full-cover-salud"}, //faltan ids reales
                {id: 3, color: "#4DCEC1", name: "Foodie", icon: "food-and-restaurant.png", bg: "min-cover-foodie.png", cover: "full-cover-foodie"},
                {id: 2, color: "#FFB56B", name: "Estudiante", icon: "inclusive-growth.png", bg: "min-cover-estudiante.png", cover: "full-cover-estudiante"},
            ],
            currentCategory: {},
            loading: true,
        }
    },
    methods:{
        getFrontURL(){
			return window.location.origin;
		},

        async getCupones(){
            const userData = JSON.parse(localStorage.getItem("userData"));
            const usuarioId = userData?.usuario_id || 2;

            const response = await fetch('https://promo-colaboradores.ideeo.mx/api/cupones-categoria', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    usuario_id: usuarioId,
                    categoria_id: this.categoryId
                })
            });

            const result = await response.json();

            this.cuponesData = [];
            for (let i of result.data) {
                const cat = this.parseCategoriaId(i.categoria_id);

                if ((i.activo === 1 || i.activo === "1") && cat.includes(this.categoryId)) {
                    this.cuponesData.push(i);
                }
            }

            this.loading = false;
        },

        getCategoryInDict(){
            const dict = this.categoryDict;
            for(let i of dict)
                if(this.categoryId == i.id) return this.currentCategory = i;
        },

        categoryHelper(arr, name, id){
            const ARR = JSON.parse(arr || []);
            const cat = {
                "1": "a la aventura",
                "2": "estudiante",
                "3": "foodie",
                "5": "mundo fitness",
                "6": "mundo digital",
                "7": "vida en compañia",
                "11": "vida independiente",
                "12": "detalles que inspiran",
                "13": "eco vibes",
                "14": "cuida tu salud"
            };
            let result = `<div style="color:black; text-decoration:none;"> <span style="color:white; background-color:blue;">${ name } (${id})</span> <br/>`;
            for(let i of ARR){
                result += `${ i == this.categoryId ? '<b style="color:blue; text-decoration:underline;">' : '' }
                    ${i}: ${cat[i.toString()]}
                ${ i == this.categoryId ? '</b>' : '' }<br/>`;
            }
            return `${result}</div>`;
        },

        parseCategoriaId(value) {
            if (!value) return [];

            if (Array.isArray(value)) return value.map(Number);

            try {
                const parsed = JSON.parse(value);
                return Array.isArray(parsed) ? parsed.map(Number) : [Number(parsed)];
            } catch (e) {
                return value
                    .toString()
                    .split(',')
                    .map(n => Number(n.trim()))
                    .filter(Boolean);
            }
        },
    },
    mounted(){
        let params = new URLSearchParams(document.location.search);
        this.categoryId = params.get("categoria");
        this.categoryId = parseInt(this.categoryId);

        this.getCupones();
        this.getCategoryInDict();
    }
}
</script>

<style scoped>
.CategoriaDetalle-MAIN{
    font-family: 'Benton Sans BBVA book';
    color: #0D2F6E;
}

.INNER-MARGIN{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.INNER-MARGIN > div:first-child{
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.INNER-MARGIN > div:first-child > img{
    margin: 0;
}

h1{
    font-family: 'Benton Sans BBVA medium';
    margin: 0;
    margin-left: 1ch;
    margin-right: -1ch;
    color: #92C8FB;
    font-size: 2.5ch;
    margin: 0;
}

.INNER-MARGIN > img{
    width: 18ch !important;
}

.INNER-MARGIN > div:not(:first-child){
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1ch;
    margin-top: 3ch;
    margin-bottom: 6ch;
    width: 90%;
}

/* provisional */
.CategoriaDetalle-MAIN img{
    width: 100%;
}

a{
    text-decoration: none;
}

/* RESPONSIVE */
@media all and (max-width:780px){

    .INNER-MARGIN > div:not(:first-child){
        grid-template-columns: 1fr 1fr;
    }

}
</style>